'use client';
import { resolveImageAlt } from '@eliadmin/core/src/utils/image-alt-utils';


import Image from 'next/image';
import Link from '@eliadmin/core/src/components/link';

import type { TDynamicData } from '@eliadmin/core/src/api/dynamics/dynamics-api';

import { cn } from '@eliadmin/core/src/utils/style-utils';
import { Heading } from '../ui/heading';
import { Paragraph } from '../ui/paragraph';
import { Button } from '../ui/button';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { useBreakpoint } from '@eliadmin/core/src/hooks/use-breakpoint';
import type { SectionProps } from './custom-homepage';
import { ROUTES } from '@eliadmin/core/src/constants/routes';

export function Benefits({
  items,
  title,
  subtitle,
}: { items: TDynamicData[] } & Partial<SectionProps>) {
  const { t } = useTranslations();

  const isDesktop = useBreakpoint('sm');

  return (
    <section
      className={cn('custom-section', 'generic-gap bg-primary-foreground py-16 sm:py-20 lg:py-24')}
    >
      <Heading
        subtitle={subtitle}
        title={title}
        center
        className={{ container: 'w-full max-w-[788px]' }}
      />
      <div
        className={cn(
          'custom-container--xxl',
          'grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4',
        )}
      >
        {items.map(item => (
          <div
            key={item.name}
            className="col-span-1 flex w-full flex-row items-start justify-start gap-4 rounded-[20px] bg-white p-6 sm:flex-col sm:gap-12 lg:p-8"
          >
            <div className="flex max-h-14 min-h-14 min-w-14 max-w-14 items-center justify-center rounded-[15px] bg-primary/10 sm:max-h-[72px] sm:min-h-[72px] sm:min-w-[72px] sm:max-w-[72px] sm:rounded-[20px]">
              <Image
                src={item?.image?.url ?? '/images/placeholder.png'}
                alt={resolveImageAlt(item?.image, item?.name)}
                width={28}
                height={28}
                className="object-contain object-center"
              />
            </div>
            <div className="flex w-full flex-col items-start justify-start gap-3">
              <Heading title={item.name} tag={isDesktop ? 'h3' : 'h4'} as="h3" />
              <Paragraph className="w-full" size={isDesktop ? 'base' : 'lg'}>
                {item?.fields[1]?.value}
              </Paragraph>
            </div>
          </div>
        ))}
      </div>
      <Button asChild variant={'secondary'} className="w-full sm:w-fit">
        <Link href={ROUTES.PRICES()}>{t('text3670')}</Link>
      </Button>
    </section>
  );
}
